@switch (columnName) {
  @case ('quantity') {
    {{ element.quantity }} {{ element.quantityType?.name }}
  }
  @case ('orderNumber') {
    {{ element.orderNumber }}
  }
  @case ('checkbox') {
    <input
      type="checkbox"
      [(ngModel)]="element.isReceived"
      [ngModelOptions]="{ standalone: true }"
      (click)="buttonFunctions.markOrderLineAsReceived()"
    />
  }
  @case ('supplier') {
    {{ element.supplier?.name }}
  }
  @case ('orderType') {
    {{ element.orderType?.name }}
  }
  @case ('totalSumVat') {
    {{ element.totalPrice }} {{ element.currencyCode }}
  }
  @case ('sum') {
    {{ element.sum | delimitedCurrency }} {{ element.currencyName }}
  }
  @case ('priceIncludingVat') {
    {{ element.priceIncludingVat | delimitedCurrency }} {{ element.currencyName }}
  }
  @case ('account') {
    {{ element.account?.name }}
  }
  @case ('product') {
    @if (element.supplierProductInvalid) {
      <mat-icon
        matTooltip="{{ 'supplierChangedErrorDescription' | translate }}"
        matTooltipClass="tooltip"
        class="warn-icon"
      >
        warning
      </mat-icon>
    } @else {
      {{ element.product }} {{ element.storageProduct?.name }} {{ element.medicine?.name }}
      {{ element.supplierProduct?.name }}
    }
  }
  @case ('procurementArea') {
    {{ element.procurementArea | mapProcurementArea | translate }}
  }
  @case ('amountReceived') {
    <div class="received-container">
      <div>{{ totalReceivedQuantity }}/{{ element.quantity }}</div>
    </div>
  }
  @case ('markOrderLineAsReceived') {
    <app-ui-button
      buttonType="icon-button"
      [icon]="
        totalReceivedQuantity === element.quantity
          ? 'check_circle_outline'
          : 'radio_button_unchecked'
      "
      [class.checked]="totalReceivedQuantity === element.quantity"
      (click)="buttonFunctions.markOrderLineAsReceived()"
      tooltip="{{ 'markAllAsReceivedButtonDescription' | translate }}"
    ></app-ui-button>
  }
  @case ('markAsReceived') {
    <app-ui-button
      buttonType="icon-button"
      icon="library_add_check"
      (click)="buttonFunctions.markReceivedAmount()"
      tooltip="{{ 'markAsReceivedButtonDescription' | translate }}"
    ></app-ui-button>
  }
  @case ('edit') {
    <button mat-button (click)="buttonFunctions.edit()">
      <mat-icon>edit</mat-icon>
    </button>
  }
  @case ('delete') {
    <button
      mat-button
      appConfirmDialog
      [confirmEntityName]="
        element?.medicine?.name ||
        element?.storageProduct?.name ||
        element?.supplierProduct?.name ||
        element?.product
      "
      (confirmed)="buttonFunctions.delete()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
  @case ('created') {
    <div>{{ element['createdBy'] | fullName }}</div>
    <div>{{ element.created | date }}</div>
  }
  @case ('updated') {
    <div>{{ element['updatedBy'] | fullName }}</div>
    <div>{{ element.updated | date }}</div>
  }
  @case ('department') {
    {{ element.department.name }}
  }
  @default {
    {{ element[columnName] }}
  }
}
